

exports.__esModule = true;
exports.$xoLoginPageComponent = undefined;

var _angular = require('angular');

var _miniBrowser = require('js/lib/miniBrowser');

var _integration = require('js/lib/integration');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('js/lib/index');

require('./loginEligibility');

require('./onboarding/directive');

require('./util');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-models/src/checkout/index');

require('xo-models/src/app/index');

require('xo-ui-components/src/message/directive');

require('xo-title/dist/directive');

require('xo-login-components/src/login/handler/directive');

require('xo-page-components/src/value-props/directive');

require('xo-form-components/src/language-options/directive');

require('xo-login-components/src/unified-login/directive');

require('xo-device-info/dist/index');

require('xo-login-components/src/onetouch-interstitial/kmliUpsell');

require('pages/xo-landing/route');

require('xo-ui-components/src/card-loader/directive');

var _squid = require('squid');

var _uiRouter = require('uiRouter');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoLoginPageComponent = exports.$xoLoginPageComponent = _squid.$Component.extend('$xoLoginPageComponent', {
    tag: 'xo-login-page',
    template: _template2['default'],
    scope: {
        token: '='
    },
    link: function link($scope) {
        _logger.$logger.info('login_link');
    },
    lifecycle: {
        populate: function populate() {
            var $scope = this;
            (0, _squid.$populate)($scope, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
            }).then(function () {

                var country = $scope.checkoutAppData.merchant.merchant_country;
                (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_hide_cart_logo_treatment').then(function (result) {
                    var treatmentName = result && result.treatment_name || '';
                    if (treatmentName) {
                        _logger.$logger.info('xo_hermesnode_hide_cart_logo_treatment');
                        $('.cartContainer').hide();
                        $('.merchantHeader > .headerWrapper').hide();
                    }
                });
            });
        },
        exit: function exit() {

            var $scope = this;
            (0, _squid.$populate)($scope, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token)
            }).then(function () {

                var country = $scope.checkoutAppData.merchant.merchant_country;
                (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_hide_cart_logo_treatment').then(function (result) {
                    var treatmentName = result && result.treatment_name || '';
                    if (treatmentName) {
                        $('.cartContainer').show();
                        $('.merchantHeader > .headerWrapper').show();
                    }
                });
            });
        }
    },

    rootEvents: {
        allLoaded: function allLoaded() {
            if (!_integration.$integration.getConfig('ALLOW_AUTH')) {
                if (_integration.$integration.getConfig('CAN_FRAMEBUST')) {
                    if (window.paypalCheckout) {
                        _uiRouter.$state.go('checkout.framebust', { action: 'open', url: window.location.href.split('#')[0] });
                    } else {
                        return _miniBrowser.$miniBrowser.frameBust(this.props.token);
                    }
                } else {
                    throw _integration.$integration.error('Can not framebust');
                }
            }
        }
    },

    controller: function controller($scope, $FallbackError, $window, $location, $locale, // eslint-disable-line no-shadow
    $FlowEligibilityModel, $CheckoutSessionModel, $BuyerEligibilityModel, $EConsentModel, $AuthModel, $feature, // eslint-disable-line no-shadow
    $AppDataModel, $config, $logger, // eslint-disable-line no-shadow
    $q, $pxp, // eslint-disable-line no-shadow
    $pxpFactors, $timeout, $util, // eslint-disable-line no-shadow
    $experiment, $loginEligibility, $dispatch, $DeviceInfo, $KmliUpsell, $ReturnToMerchant, $meta, $stateParams, $CheckoutCartModel, $CreditDataModel, $capeRedirectUtil) {

        $logger.info('login_controller');

        var fptiHardErrors = ['RESTRICTED_USER', 'PAYEE_BLOCKED_TRANSACTION', 'PAYMENT_ALREADY_DONE', 'PAYMENT_DENIED', 'PAYEE_ACCOUNT_RESTRICTED', 'INVALID_RESOURCE_ID', 'EXPIRED_SESSION', 'PAYER_COUNTRY_NOT_ALLOWED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED'];

        $scope.ulEligibility = false;
        $scope.useTokenizationAnimation = false;

        /* If we detect a back/forward button click to land on the app, do not auto-login. In this case, the buyer
         is attempting to navigate to a specific page, so we should not auto-redirect them.
          This also fixes an issue with users:
         - Authorizing the checkout session
         - Redirecting to the merchant
         - Hitting back and landing on login page
         - Calling create on checkout and overwriting the authorization
         - Hitting forward and landing again on merchant page
         */

        if (window.performance && window.performance.navigation && window.performance.navigation.type === 2) {
            _angular.$rootScope.forceLogin = true;
        }

        if (!_angular.$rootScope.forceLogin) {
            $scope.autoLogin = true;
        }

        _angular.$rootScope.forceLogin = true;

        $scope.hideGuest = $stateParams.targetPage === 'PAYER_AUTHENTICATION_REQUIRED' || $stateParams.showNotYou;
        $scope.promptlogin = $scope.hideGuest && !$feature('riskyLoginContingency');

        // log statement for mobile webview
        if ($DeviceInfo.isApp()) {
            $logger.debug('HERMES_IN_MOBILE_WEBVIEW');
        }

        if (!_miniBrowser.$miniBrowser.isMiniBrowser() && $locale.country === 'BR') {
            var brPxp = $config.pxpExperiments.BR.xo_br_hermesnode_login_design;

            $pxpFactors(brPxp.pgName, brPxp.params, brPxp.pattern).then(function (result) {
                $scope.loginDesignExp = result;
            });
        }

        var ROUTE_MAPPING = {
            ECONSENT_REQUIRED: 'checkout.econsent'
        };

        $scope.onContingency = function (name, contingency) {

            if (!ROUTE_MAPPING[name]) {
                throw new $FallbackError({
                    reason: name.toLowerCase(),
                    product: 'ux'
                });
            }

            _uiRouter.$state.go(ROUTE_MAPPING[name]);
        };

        $scope.isWPS = _angular.$rootScope.wps; // used in template. do not remove
        $scope.buyerEligibility = $BuyerEligibilityModel.instance($scope.token);
        $scope.checkoutSession = $CheckoutSessionModel.instance($scope.token);
        $scope.eConsent = $EConsentModel.instance($scope.token);

        // Temporary light eligibility check for tokenized wallet flow.
        function isWalletTokenizationEligible() {
            // Only US buyer is eligible for tokenized wallet.
            if ($scope.auth.country === 'US') {
                return true;
            }
            return false;
        }

        $scope.setBuyer = function () {

            var fptiData = {
                from: 'CREATE_XO_SESSION',
                to: 'process_create_xo_session'
            };

            $logger.info('checkout_fpti', {
                from: 'CREATE_XO_SESSION',
                to: 'prepare_create_xo_session'
            });

            $scope.useTokenizationAnimation = $scope.checkoutCart.isWalletTokenization();
            if ($scope.useTokenizationAnimation) {
                _angular.$rootScope.$emit('allLoaded');

                $scope.setbuyerProgress = 'notStarted';
                $logger.info('tokenized_wallet', {
                    'from': 'adding_pp_ap_animation',
                    'to': 'prepare_adding_pp_ap_animation',
                    'context_id': $scope.token,
                    'context_type': 'EC-Token',
                    'ba_token': $meta.baToken
                });

                $timeout(function () {
                    $scope.setbuyerProgress = 'pending'; // sets animation state to 80%
                    $logger.info('tokenized_wallet', {
                        'from': 'adding_pp_ap_animation',
                        'to': 'process_adding_pp_ap_animation',
                        'context_id': $scope.token,
                        'context_type': 'EC-Token',
                        'ba_token': $meta.baToken
                    });
                }, 300);
            }

            $scope.eConsent.retrieve({
                batch: {
                    name: 'setbuyer',
                    silent: $scope.useTokenizationAnimation,
                    id: 'eConsent',
                    dependencies: $scope.ulEligibility ? ['securityCtx'] : []
                },
                contingencies: {
                    ECONSENT_REQUIRED: function ECONSENT_REQUIRED(name, err) {
                        $logger.debug('ULLOGIN_ECONSENT_REQUIRED');
                        _uiRouter.$state.go('checkout.econsent');
                    }
                }
            });

            $scope.buyerEligibility.retrieve({
                batch: {
                    name: 'setbuyer',
                    id: 'buyerEligibility',
                    silent: $scope.useTokenizationAnimation,
                    dependencies: ['eConsent']
                },
                success: function success(result) {
                    $logger.info(result.eligible ? 'buyer_eligible' : 'buyer_ineligible');

                    if ($config.blockStudentAccount && $scope.auth.student_account) {
                        $logger.info('stop_fallback_for_student_account');
                        return;
                    }

                    if ($scope.checkoutCart.isWalletTokenization() && !isWalletTokenizationEligible()) {
                        var msg = 'ineligible_tokenized_wallet_' + $scope.auth.country + '_account';
                        $logger.info(msg);

                        // ANDROID_PAY_ELIGIBILITY_ERROR is currently mapped to generic error.  We need adapted/
                        // localized content for eligibility error.  Mapping needs to be updated once we have
                        // adpated and localized content.
                        _uiRouter.$state.go('checkout.genericError', {
                            code: 'ANDROID_PAY_ELIGIBILITY_ERROR'
                        });
                    }

                    if (result.clearedRT) {
                        $logger.info('checkout_fpti', {
                            from: 'CONTINGENCY',
                            to: 'process_fallback',
                            routing_reason: 'BUYER_INELIGIBLE'
                        });
                    }

                    if (!result.eligible) {
                        throw new $FallbackError({
                            reason: 'buyer_ineligible',
                            product: 'ux'
                        });
                    }
                }
            });

            $scope.checkoutSession.action('create', {
                data: {
                    baToken: $scope.checkoutCart.billing && $scope.checkoutCart.billing.ba_token,
                    preselected_fi_type: $scope.checkoutAppData.is_second_button_txn ? 'credit' : undefined
                },
                batch: {
                    name: 'setbuyer',
                    id: 'createCheckoutSession',
                    silent: $scope.useTokenizationAnimation,
                    dependencies: ['eConsent', 'buyerEligibility']
                },
                success: function success(result) {
                    $logger.info('checkout_fpti', fptiData);

                    if ($config.blockStudentAccount && $scope.auth.student_account) {
                        $logger.info('blocking_student_account');
                        _uiRouter.$state.go('checkout.genericError', {
                            code: 'STUDENT_ACCOUNT'
                        });
                        return;
                    } else if (!$scope.buyerEligibility.eligible) {
                        return;
                    } else if ($scope.checkoutCart.isWalletTokenization() && !isWalletTokenizationEligible()) {
                        return;
                    }

                    if ($scope.auth.password_less && $scope.checkoutCart.isBilling()) {
                        if ($feature('pomaPasswordRecovery')) {
                            _uiRouter.$state.go('checkout.createPassword', { targetPage: 'BILLING_AGREEMENTS' });
                        }
                        return;
                    }

                    if ($scope.checkoutAppData.is_second_button_txn) {
                        return $capeRedirectUtil.handleCapeRouting(result, $scope.token);
                    }

                    return $KmliUpsell.eligible($scope.token).then(function (isEligible) {
                        if (isEligible.eligible) {

                            var stateName = isEligible.type === 'member' ? 'KMLI_UPSELL' : 'KMLI_reactivation';

                            $logger.info('checkout_fpti', {
                                from: stateName,
                                to: 'prepare_kmli_upsell'
                            });

                            var path = $DeviceInfo.isMobile() ? 'checkout.FullpageOnetouchUpsell' : 'checkout.review.oneTouchUpsell';

                            return _uiRouter.$state.go(path, { oneTouchFlowName: 'checkout' });
                        }

                        if ($scope.auth.rtExchanged && $feature('rmSpinnerText')) {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['login.loggedInWithOneTouch']
                            };
                        }

                        if ($scope.checkoutSession.negBals) {
                            return _uiRouter.$state.go('checkout.negativeBalanceRecovery');
                        }

                        if ($scope.checkoutCart.isWalletTokenization()) {
                            $logger.info('tokenized_wallet', {
                                'from': 'PP_AndroidPay_Info',
                                'to': 'prepare_PP_AndroidPay_Info',
                                'context_id': $scope.token,
                                'context_type': 'EC-Token',
                                'ba_token': $meta.baToken
                            });
                            $timeout(function () {
                                return _uiRouter.$state.go('checkout.tokenizationInfo');
                            }, 1200);
                        } else {
                            _uiRouter.$state.go('checkout.review');
                        }
                    });
                },
                contingencies: {
                    // override contingency.js handler with custom logic to support both xoon/hermes flows
                    NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, err) {
                        // come from guest or have alternate FI options, go to review
                        if ($util.param('redirectToHermesOnUpopCancel') === 'xoon' || err && err.resolution && err.resolution.data && err.resolution.data.alternate_options) {
                            _uiRouter.$state.go('checkout.review');
                        } else {
                            // else go to addCard
                            _uiRouter.$state.go('checkout.updateCard.addCardFlow.addCard');
                        }
                    },
                    DEFAULT: function DEFAULT(name, err) {
                        fptiData.int_error_code = err.cause;
                        fptiData.error_source = 'paymentapiplatformserv';
                        fptiData.error_type = fptiHardErrors.indexOf(err.cause) > -1 ? 'hard_decline' : 'soft_decline';
                        $logger.info('checkout_fpti', fptiData);
                        throw err;
                    }
                }
            });
        };

        // Sorry for the indirection here.  There's postAuth, so "preAuth" compliments it well (easier on the brain)
        $scope.preAuth = function () {

            // For UL, batch up eConsent, buyerEligibility, xoSession
            if ($scope.ulEligibility) {
                $scope.setBuyer();
            }
        };

        $scope.onSuccess = function () {

            // If the experiment is enabled, we already have what we need, so /quit.
            if ($scope.ulEligibility) {
                return;
            }

            $scope.setBuyer();
        };

        function fetchGuestButtonPxpVarients() {
            $scope.guestVariant = {};
            // PXP for showing Guest button Call-To-Actions
            return $pxp('xo_hermesnode_guest_cta', {
                'ctx.COUNTRY': $locale.country
            }, '(xo_hermesnode_guest_cta_)(.*)').then(function (result) {
                var treatmentName = result && result.treatment_name || '';

                switch (treatmentName) {
                    case 'xo_hermesnode_guest_cta_standard_label_treatment':
                        $scope.guestVariant.standardGuestBtn = true;
                        $scope.guestVariant.test = true;
                        break;
                    case 'xo_hermesnode_guest_cta_card_icons_treatment':
                        $scope.guestVariant.cardIconsAboveGuestBtn = true;
                        $scope.guestVariant.test = true;
                        break;
                    default:
                    // Do nothing
                }
            });
        }

        (0, _squid.$populate)($scope, {
            flowEligibility: $FlowEligibilityModel.instance($scope.token).retrieve({
                params: {
                    geolocation: $meta.geolocation,
                    localeCountry: $locale.country // We need this till we completely migrate to server side locale resolution
                }
            }),
            auth: $AuthModel.instance(),
            checkoutAppData: _index.$CheckoutAppDataModel.instance($scope.token),
            checkoutCart: $CheckoutCartModel.instance(_angular.$rootScope.token)
        }).then(function () {
            if ($scope.flowEligibility.guest) {
                return fetchGuestButtonPxpVarients();
            }
            $('.paypalHeaderWrapper').removeClass('paypalCredit');
            $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
        }).then(function () {
            if ($scope.auth.accessToken()) {
                return $scope.auth.reload({
                    headers: {
                        'x-paypal-internal-euat': $scope.auth.accessToken()
                    },
                    resultModel: $scope.auth,
                    success: function success() {
                        delete $scope.auth.access_token;
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name) {
                            throw new $FallbackError({
                                reason: name.toLowerCase(),
                                product: 'ux'
                            });
                        }
                    }
                });
            }
        }).then(function () {
            return $loginEligibility($scope.token, !$scope.autoLogin).then(function (result) {
                if (result === 'unifiedLogin') {
                    $scope.ulEligibility = true;
                } else if (result === 'apsIntegration') {
                    $scope.apsIntegration = 'apsIntegration';
                } else if (result === 'apsIntegrationRM') {
                    $scope.apsIntegration = 'apsIntegrationRM';
                }
            }).then(function () {

                var reinitDisplay = function reinitDisplay() {
                    $scope.promptlogin = false;
                    $scope.hideGuest = false;
                    $scope.autoLogin = true;
                    delete $stateParams.targetPage;
                    delete $stateParams.showNotYou;
                };

                $scope.logout = $scope.promptlogin ? function () {
                    $logger.info('not_you_logout');
                    $logger.info('checkout_fpti', {
                        from: 'LOGIN_UL',
                        to: 'login_with_diff_user'
                    });
                    $scope.auth.action('logout').then(function () {
                        $scope.auth.reload().then(function () {
                            reinitDisplay();
                            $scope.reload();
                        });
                    });
                } : function () {
                    $logger.info('logout_switch_display');
                    reinitDisplay();
                };
            });
        });
    }
});

angular.value("$xoLoginPageComponent", $xoLoginPageComponent);
_angular.$rootScope;

_miniBrowser.$miniBrowser;

_integration.$integration;

_squid.$Component;

_squid.$pxp;

_squid.$populate;

_logger.$logger;

_index.$CheckoutAppDataModel;

_uiRouter.$state;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-login/directive.js
// module id = ./pages/xo-login/directive.js
// module chunks = 1